module.exports = __webpack_public_path__ + "img/main-header.fc1fbee7.png";